export const isArray =  (array) => Array.isArray(array)